import SegmentBasedInplayScoreboard from 'presentation/components/scoreboard/segment-based-inplay-scoreboard/index.js';
import MojitoCore from 'mojito/core';
import { range } from 'mojito/utils';
import * as utils from '../utils.js';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class SetBasedInplayScoreboard extends UIViewImplementation {
    getSetName(setNumber) {
        const { sportId } = this.props.event;
        return utils.getSegmentName(setNumber, sportId, 'DEFAULT_SET', this.l10n);
    }

    getTotalScoreString() {
        const { sportId } = this.props.event;
        const systemSettings = this.appContext().systemSettings();
        return utils.getTotalScoreString(sportId, systemSettings, this.l10n);
    }

    getMappedSets() {
        const { event } = this.props;
        const participantsPosition = utils.getParticipantsPosition(event);
        const currentNumberOfSegments = event.details.detailedScores.length;
        const columns = range(currentNumberOfSegments);

        return columns.map((x, i) => {
            const segmentScores = event.details.detailedScores[i] || {};
            const scores = [
                segmentScores[participantsPosition[0]],
                segmentScores[participantsPosition[1]],
            ];
            const index = i + 1;
            const selected = index === event.details.segmentNumber;

            return {
                header: this.getSetName(index),
                scores,
                selected,
            };
        });
    }

    getDetailedParticipantsData() {
        const { event } = this.props;
        const hasGameScores =
            this.config.displayGameScoreInsteadOfTotalScore.indexOf(event.sportId) !== -1;
        const totalScores = hasGameScores ? 'gameScores' : 'totalScores';
        return utils.getDetailedParticipantsData(event, totalScores);
    }

    render() {
        const { event } = this.props;

        if (!event || !event.details || !event.details.detailedScores) {
            return null;
        }

        const detailedSegments = this.getMappedSets();
        const displayStrings = {
            totalScore: this.getTotalScoreString(),
        };

        return (
            <SegmentBasedInplayScoreboard
                config={this.config.segmentBasedInplayScoreboard}
                event={event}
                detailedParticipantsData={this.getDetailedParticipantsData()}
                hasServer={!!event.details.server}
                detailedSegments={detailedSegments}
                displayStrings={displayStrings}
                inplayTime={this.props.inplayTime}
                hasClockDetails={this.props.hasClockDetails}
            />
        );
    }
}
